import {
    onboardingSubscriptionPlansResponseSchema,
    type OnboardingSubscriptionPlan,
} from '@houzy/schemas/partner-cockpit/onboarding';
import { queryOptions, useSuspenseQuery, type UseSuspenseQueryResult } from '@tanstack/react-query';

import { apiRequest, retryQueryUnlessClientError } from '../../../lib/api';
import { partnerCockpitApiPath } from '../../../lib/config';
import { STALE_TIME_MS } from '../../../lib/queryClient';

export async function fetchPlans(signal?: AbortSignal): Promise<OnboardingSubscriptionPlan[]> {
    const response = await apiRequest(partnerCockpitApiPath('onboarding/subscription/plans'), {
        signal,
        responseSchema: onboardingSubscriptionPlansResponseSchema,
    });
    return response.plans;
}

export const plansQueryOptions = queryOptions({
    queryKey: ['onboarding', 'subscription', 'plans'],
    queryFn: ({ signal }) => fetchPlans(signal),
    staleTime: STALE_TIME_MS,
    retry: retryQueryUnlessClientError,
});

export function usePlans(): UseSuspenseQueryResult<OnboardingSubscriptionPlan[]> {
    return useSuspenseQuery(plansQueryOptions);
}
